﻿import LandingPage from "./Registration/LandingPage.svelte";
import PersonalDetails from "./Registration/PersonalDetails.svelte";
import ActionSpecific from "./Registration/ActionSpecific.svelte";
import Confirmation from "./Registration/Confirmation.svelte";
import Review from "./Registration/Review.svelte";
import ThankYou from "./Registration/ThankYou.svelte";
import SaveAndCloseThankYou from "./Registration/SaveAndCloseThankYou.svelte";
import Verify from "./Registration/Verify.svelte";
import EmploymentDetails from "./Registration/EmploymentDetails.svelte";
import Employment from "./Registration/Employment.svelte";
import AdditionalDetails from "./Registration/AdditionalDetails.svelte";
import { slugify } from "../components/lib/helpers";
import Error from "./Error.svelte";

import { projectSettings } from "../config";

function getNextPage(model, businesses, isFromEmployment) {
	if (isFromEmployment) {
		model.claimDetails = model.claimDetails.filter((claim) => model.selectedBusinesses.includes(claim.businessId));
	}

	console.log(model);

	const selectedBusinessObjects = businesses.filter((biz) => model.selectedBusinesses.includes(biz.businessId));

	// Sort alphabetically
	const sortedBusinesses = [...selectedBusinessObjects].sort((a, b) => a.businessName.localeCompare(b.businessName));

	// If no current business, start from the beginning (alphabetically)
	if (!model.currentBusiness) {
		const firstBusiness = sortedBusinesses[0];
		const route = `/Registration/Employment/${slugify(firstBusiness.businessName)}`;
		console.log("returning:", route);
		return route;
	}

	const currentBusinessId = model.currentBusiness.businessId;
	const index = sortedBusinesses.findIndex((biz) => biz.businessId === currentBusinessId);

	if (index < sortedBusinesses.length - 1) {
		const nextBusiness = sortedBusinesses[index + 1];
		const route = `/Registration/Employment/${slugify(nextBusiness.businessName)}`;
		return route;
	}

	return "/Registration/AdditionalDetails";
}

function getPreviousPage(model, businesses) {
	console.log(model);

	if (!model.currentBusiness) {
		let business = businesses.find((biz) => {
			if (model.claimDetails.length > 0) {
				return model.claimDetails[model.claimDetails.length - 1].businessId == biz.businessId;
			}
			return model.selectedBusinesses[model.selectedBusinesses.length - 1] == biz.businessId;
		});
		const route = `/Registration/Employment/${slugify(business.businessName)}`;
		console.log("returning:", route);
		return route;
	}

	const currentBusinessId = model.currentBusiness.businessId;

	// Filter to only selected businesses
	const selectedBusinessObjects = businesses.filter((biz) => model.selectedBusinesses.includes(biz.businessId));

	// Sort alphabetically by businessName
	const sortedBusinesses = selectedBusinessObjects.sort((a, b) => a.businessName.localeCompare(b.businessName));

	// Find the current business in the sorted list
	const index = sortedBusinesses.findIndex((biz) => biz.businessId === currentBusinessId);

	if (index > 0) {
		const previousBusiness = sortedBusinesses[index - 1];
		const route = `/Registration/Employment/${slugify(previousBusiness.businessName)}`;
		return route;
	}

	return "/Registration/Employment";
}

export const registrationPageList = [
	{
		pageIndex: 0,
		component: LandingPage,
		title: "Claimant Registration Form",
		showInTracker: true,
		routeId: "/Registration",
		//nextPage: "/Registration/ActionSpecific",
		nextPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${projectSettings.classActionName}`,
			lastVisitedPage: "Landing Page"
		}
	},
	{
		pageIndex: 1,
		component: PersonalDetails,
		title: "Personal Details",
		showInTracker: true,
		routeId: "/Registration/PersonalDetails",
		nextPage: "/Registration/Employment",
		previousPage: "/Registration",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Personal Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Personal Details"
		}
	},
	{
		pageIndex: 2,
		component: Employment,
		title: "Employment Details",
		showInTracker: false,
		routeId: "/Registration/Employment/",
		nextPage: (model, businesses) => getNextPage(model, businesses, true),
		previousPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Employment Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Personal Details"
		}
	},
	{
		pageIndex: 3,
		component: EmploymentDetails,
		title: "Employment",
		showInTracker: true,
		routeId: "/Registration/Employment/:slug",
		nextPage: (model, businesses) => getNextPage(model, businesses),
		previousPage: (model, businesses) => getPreviousPage(model, businesses),
		properties: {
			pageTitle: `${projectSettings.classActionName} - Personal Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Employment Details"
		}
	},
	{
		pageIndex: 4,
		component: AdditionalDetails,
		title: "Additional Details",
		showInTracker: true,
		routeId: "/Registration/AdditionalDetails",
		previousPage: (model, businesses) => getPreviousPage(model, businesses),
		nextPage: "/Registration/Confirmation",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Additional Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "AdditionalDetails"
		}
	},
	{
		pageIndex: 5,
		component: Confirmation,
		title: "Confirmation",
		showInTracker: true,
		routeId: "/Registration/Confirmation",
		previousPage: "/Registration/AdditionalDetails",
		nextPage: "/Registration/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Confirmation`,
			nextPageLabel: "Submit",
			persistUrl: `/api/registration?timezoneOffset=${-1 * new Date().getTimezoneOffset()}`,
			lastVisitedPage: "Confirmation"
		}
	},
	{
		pageIndex: 4,
		component: ThankYou,
		title: "Registration Submitted",
		showInTracker: false,
		routeId: "/Registration/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Thank you`
		}
	},
	{
		pageIndex: 4,
		component: SaveAndCloseThankYou,
		title: "Registration Saved",
		showInTracker: false,
		routeId: "/Registration/SaveAndClose",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Thank you`
		}
	},
	{
		pageIndex: 5,
		component: Review,
		title: "Review",
		showInTracker: false,
		routeId: "/Review",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Review`
		}
	},
	{
		pageIndex: 6,
		component: Verify,
		title: "Claimant Registration Form",
		showInTracker: false,
		routeId: "/Verify",
		nextPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Verify`
		}
	},
	{
		pageIndex: 7,
		component: Error,
		title: "Error",
		showInTracker: false,
		routeId: "*/Error",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Error`
		}
	}
];
